import React, { useEffect, useState } from 'react'
import { CCol, CForm, CFormInput, CFormLabel, CInputGroup, CInputGroupText, CRow } from '@coreui/react';
import { Dialog } from 'primereact/dialog';
import { Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useChoice } from '../contexts/ChoicesContext';
import { useCompanySetting } from '../contexts/CompanySettingContext';
import ChoiceSelection from './ChoiceSelection';

function AddChoiceInCombo({ choiceVisible, editChoiceId, comboDetails, setChoiceVisible, setEditChoiceId, setComboDetails }) {
    const { getSingleChoice } = useChoice()
    const { currency } = useCompanySetting()
    const { toast } = useAuth()

    const [newChoiceId, setNewChoiceId] = useState(null)
    const [choiceValidated, setChoiceValidated] = useState(false)
    const [validated, setValidated] = useState(false);
    const [choiceDetail, setChoiceDetail] = useState({
        id: null,
        name: "",
        products: [],
        totalPrice: 0
    })

    useEffect(() => {
        fetchSingleChoice();
    }, [newChoiceId]);

    const fetchSingleChoice = async () => {
        if (newChoiceId && !editChoiceId) {

            const choice = await getSingleChoice(newChoiceId.value)
            setChoiceDetail({
                id: choice.id,
                name: choice.name,
                products: choice.choiceProducts
            });
        } else if (editChoiceId) {
            const choice = comboDetails.choices.filter((c) => c.id === editChoiceId.value)

            if (choice.length !== 0) {
                let { name, id, products } = choice[0]

                setNewChoiceId(editChoiceId)
                setChoiceDetail({
                    id: id,
                    name: name,
                    products: products.map((p) => {
                        return {
                            ...p,
                            modified_price: parseFloat(p.modified_price).toFixed(2)
                        }
                    })
                });
            }
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);
        choiceDetail.id ? setChoiceValidated(false) : setChoiceValidated(true)

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (choiceVisible && choiceDetail.id) {

                    const isexistingChoice = comboDetails.choices.length !== 0 && comboDetails.choices?.filter((c) => c.id === choiceDetail.id)
                    if (isexistingChoice.length > 0) {
                        toast.current?.show({ severity: 'error', summary: 'Choice', detail: "Choice already added in combo. Please select another choice.", life: 3000 })
                    } else {
                        const choiceData = {
                            ...choiceDetail,
                            totalPrice: choiceDetail.products.reduce((acc, product) => acc + (parseFloat(product.modified_price) || 0), 0)
                        }

                        if (comboDetails.choices.length !== 0) {
                            setComboDetails({ ...comboDetails, choices: [...comboDetails.choices, choiceData] });
                        } else {
                            setComboDetails({ ...comboDetails, choices: [choiceData] });
                        }

                        handleClose()
                    }
                } else if (editChoiceId.value && choiceDetail.id) {

                    const choiceData = {
                        ...choiceDetail,
                        totalPrice: choiceDetail.products.reduce((acc, product) => acc + (parseFloat(product.modified_price) || 0), 0)
                    }

                    const updatedChoices = comboDetails.choices.map((choice) =>
                        choice.id === choiceDetail.id ? choiceData : choice
                    );

                    setComboDetails({
                        ...comboDetails,
                        choices: updatedChoices
                    });

                    handleClose();
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleProductPriceChange = (productId, newPrice) => {
        setChoiceDetail(prevDetail => {
            const updatedProducts = prevDetail.products.map(product =>
                product.id === productId ? { ...product, modified_price: parseFloat(newPrice) } : product
            );
            return {
                ...prevDetail,
                products: updatedProducts,
            };
        });
    };

    const handleClose = () => {
        setChoiceVisible(false);
        setEditChoiceId(null)
        setNewChoiceId(null)
    }

    return (
        <>
            <Dialog draggable={false} header={`${choiceVisible ? 'Add Choice' : 'Edit Choice'}`} visible={choiceVisible || editChoiceId !== null} style={{ width: "35vw" }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className='mb-3 mt-3'>
                            <ChoiceSelection
                                className='d-flex'
                                labelClassName='w-50'
                                value={newChoiceId}
                                onChange={(value) => setNewChoiceId(value)}
                                multiSelect={false}
                                disabled={editChoiceId}
                                required={true}
                                error={choiceValidated}
                            />
                        </CRow>
                        <CRow className='mb-3'>
                            <div className='mb-2'>
                                <CFormLabel>
                                    Products
                                </CFormLabel>
                            </div>
                            <div>
                                {choiceDetail && choiceDetail.products.length > 0 ? (
                                    choiceDetail.products.map((product) => {
                                        return (
                                            <CRow key={product.id} className='mb-3'>
                                                <CCol lg={4}>
                                                    <CFormLabel className="form-label w-100">{product.productName}</CFormLabel>
                                                </CCol>
                                                <CCol lg={4} className='ps-0'>
                                                    <CInputGroup>
                                                        <CInputGroupText id="basic-addon1">
                                                            {currency}
                                                        </CInputGroupText>
                                                        <CFormInput
                                                            type="number"
                                                            step="any"
                                                            min={0}
                                                            value={product.productPrice}
                                                            disabled
                                                        />
                                                    </CInputGroup>
                                                </CCol>
                                                <CCol lg={4} className='ps-0'>
                                                    <CInputGroup>
                                                        <CInputGroupText id="basic-addon1">
                                                            {currency}
                                                        </CInputGroupText>
                                                        <CFormInput
                                                            type="number"
                                                            step="any"
                                                            min={0}
                                                            value={product.modified_price}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                if (newValue >= 0) {
                                                                    handleProductPriceChange(product.id, newValue);
                                                                }
                                                            }}
                                                            required
                                                            feedbackInvalid='Price is required.'
                                                        />
                                                    </CInputGroup>
                                                </CCol>
                                            </CRow>
                                        );
                                    })
                                ) : (
                                    'Products not found.'
                                )}
                            </div>
                        </CRow>
                    </div>
                    <div className={`button-container d-flex ${editChoiceId ? 'justify-content-between' : 'justify-content-end'}`}>
                        {
                            editChoiceId && (
                                <div>
                                    <Button color='error' variant="contained">
                                        Delete
                                    </Button>
                                </div>
                            )
                        }
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                Submit
                            </Button>
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </>
    )
}

export default AddChoiceInCombo